import { render } from "./ResourceGroupInfo.vue?vue&type=template&id=a920657e&scoped=true"
import script from "./ResourceGroupInfo.vue?vue&type=script&lang=js"
export * from "./ResourceGroupInfo.vue?vue&type=script&lang=js"

import "./ResourceGroupInfo.vue?vue&type=style&index=0&id=a920657e&scoped=true&lang=css"

import exportComponent from "/build/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a920657e"]])

export default __exports__